module.exports = __webpack_public_path__ + "img/Donnie Chesteen.597970fb.jpg";